import api from './api';

export const mfaService = {
  async sendCode(email, type) {
    return api.post('/mfa/send', { email, type });
  },

  async verifyCode(email, code, type) {
    return api.post('/mfa/verify', { email, code, type });
  }
};

export default mfaService;
